<template>
    <div class="container">
        <div class="meet-level trans">
            <meet-header
                :headerConfig="headerConfig"
                @handleClickIocn="handleClickIocn"
            />

            <div class="main">
                <h2 class="tit">参会须知列表</h2>
                <!-- <div class="meet-notice-list" v-for="(item,i) in informList" :key="i">
                    <div @click="handleDetails(item)" class="item shadow"><span class="notice-tit">{{item.name}}</span><span class="time">查看详情</span></div>    
                </div> -->
                <div class="meet-notice-list">
                    <div @click="handleDetails('notice')" class="item shadow"><span class="notice-tit">防疫须知</span><span class="time">查看详情</span></div>    
                    <div @click="handleDetails('hint')" class="item shadow"><span class="notice-tit">温馨提示</span><span class="time">查看详情</span></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import meetHeader from "@/components/header";

export default {
    name: "meetLevel",
    components: {
        meetHeader,
    },
    data() {
        return {
            headerConfig: {
                headerIcon: "city ct-xiangyou",
                headerTitle: "会议概况信息",
            },
            noticelist:[]
        };

    },
    async created(){
        if (this.$route.params.noticelist) {
            this.noticelist = this.$route.params.noticelist
        }else {
            let currentConference = await this.$store.dispatch("conference/getCurrentConference")
            this.noticelist = currentConference.notices
        }
    },
    methods: {
        handleClickIocn() {
            history.go(-1);
        },
        handleDetails(param){
            if(this.noticelist.length >0){
                    if(param == 'hint'){
                        this.$router.push({ name: "hintdetail", params: { notice: this.noticelist[0] }})
                    }else{
                        this.$router.push({ name: "noticedetail", params: { notice: this.noticelist[0] }})
                    }
            }else{
                this.$message('暂无相关信息')
            }
                       
        }
    },
};
</script>

<style lang="scss" scoped>
.main {
    width: 100%;
    padding: 0 15px;
    margin-bottom: 30px;
    box-sizing: border-box;

    .tit {
        padding-left: 8px;
        margin-top: 30px;
        border-left: 4px solid var(--main-color);
        font-size: 18px;
        font-weight: bold;
        color: var(--main-color);
    }

   
    .meet-notice-list {
        width: 100%;
        margin-top: 30px;

        .item {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 10px;
            height: 30px;
            border-radius: 5px;
            margin-bottom: 15px;

            &:last-child {
                margin-bottom: 0;
            }

            .notice-tit {
                font-size: 14px;
            }

            .time {
                font-size: 12px;
            }
        }
    }
}
</style>